import { render, staticRenderFns } from "./del-new-modal.vue?vue&type=template&id=c8914ef2&scoped=true"
import script from "./del-new-modal.vue?vue&type=script&lang=ts"
export * from "./del-new-modal.vue?vue&type=script&lang=ts"
import style0 from "./del-new-modal.vue?vue&type=style&index=0&id=c8914ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8914ef2",
  null
  
)

export default component.exports